import React from 'react'
import { Route } from 'react-router'
import * as Views from './views'

const Routes = (
  <Route>
    <Route path="application" component={Views.Application} />
  </Route>
)

export default Routes
